<template>
    <Navbar></Navbar>
    <div class="page-box">
        <div class="img-box page-banner">
            <img data-src="/assets/manufacture/engine/taizhou/tz.jpg" alt=""></img>
            <div class="title-box">
                <div class="manufacture-t1">
                    变速器泰州工厂
                </div>
                <div class="manufacture-t2">
                    成立于2020年，基于工业4.0标准打造的全新智能化工厂，占地约20000平方米，在江苏扬中和上海嘉定设有两个研发中心；<br />
                    蜂巢蔚领实现从生产计划、物料采购、生产制造执行到仓储物流管理的全流程数字化协同，构建精益管理体系；<br />
                    增压器车间和氢燃料电池空压机车间荣获江苏省工信厅认定的智能制造示范车间等荣誉认证。
                </div>
            </div>
        </div>

        <div class="page-title-box">
            <div class="page-t1">
                核心工艺
            </div>
            <div class="page-t2">
                涵盖压轮加工、涡轮轴加工、单体动平衡、核心部件装配及动平衡、整机装配和测试。<br />
                通过覆盖全生产流程的产品和工艺防错设计及数字化防错管理体系，持续优化和工艺创新，确保产品质量更稳定，持续为客户提供高标准化、高可靠性、高一致性的产品品质。
            </div>
        </div>

        <div class="page-sw">
            <div class="swiper-container kv-container swiper-item">
                <div class="swiper-wrapper">
                    <div class="swiper-slide">
                        
                        <div class="text-box ">
                            <div class="title">
                                涡轮加工及平衡
                            </div>
                            <div class="destils">
                                整线依据工艺流程及高质量要求，选择国内外顶级品牌设备整合开发而成，主要包括：英国CVE电子束焊接设备、超声波探伤机、德国巴米勒高精度自动数控磨床、意大利CEMB全自动平衡机等，通过高精密的真空环境下的电子束焊接技术，配合100%的自动超声波探伤，确保产品的焊接强度和可靠性<br />
                                生产过程辅助以高精度光学测量仪，全流程二维码绑定实现生产过程自动化和特殊特性趋势防错预警，确保每一件产品的一致性、可追溯性和合规性<br />
                                主要工艺包括：焊接、探伤、磨削、测量和动平衡
                            </div>
                        </div>
                        <div class="img-box">
                            <img data-src="/assets/manufacture/engine/taizhou/tz1-1.jpg" alt="">
                        </div>
                    </div>

                    <div class="swiper-slide">
                        
                        <div class="text-box ">
                            <div class="title">
                                压轮加工及平衡
                            </div>
                            <div class="destils">
                                整线依据工艺流程及高质量要求，选择国内外顶级品牌设备整合开发而成，主要包括：日本村田全自动数控车床、德国巨浪高速五轴加工中心、意大利CEMB全自动平衡设备、超声波清洗机等<br />
                                通过关键特性自动化百检、激光二维码信息追溯防错系统实现从毛坯至成品加工的无人化、智能化、信息化，打造环保节能的自动生产线<br />
                                主要工艺包括：车削、铣削、去毛刺、测量和动平衡、清晰等
                            </div>
                        </div>
                        <div class="img-box">
                            <img data-src="/assets/manufacture/engine/taizhou/tz1-2.jpg" alt="">
                        </div>
                    </div>

                    <div class="swiper-slide">
                        
                        <div class="text-box ">
                            <div class="title">
                                核心体部件装配及平衡
                            </div>
                            <div class="destils">
                                装配产线为蜂巢蔚领联合国内一流自动化设备供应商并搭配意大利CEMB动平衡设备联合开发而成。主要工艺包括：预装、装配、拧紧、试漏、动平衡等<br />
                                核心体组装为自动化产线（自动化率达90%），通过配备行业内一流的高精度机器人、三维模组、电控拧紧枪、测温枪、试漏仪、压力位移传感器、视觉相机、激光传感器等，实现生产全流程自动化装配<br />
                                通过线体MES实现关键工艺特性和设备参数的100%监测和防错管理，以及配合高精密的自动化测量及动平衡设备，确保核心部件装配的一致性
                            </div>
                        </div>
                        <div class="img-box">
                            <img data-src="/assets/manufacture/engine/taizhou/tz1-3.jpg" alt="">
                        </div>
                    </div>
                    <div class="swiper-slide">
                        
                        <div class="text-box ">
                            <div class="title">
                                整机装配及测试
                            </div>
                            <div class="destils">
                                整机装配线为蜂巢蔚领联合国内一流自动化设备供应商共同开发而成。其主要工艺为压壳预装及检测、三壳装配、电控执行器组装及标定、VGT最小流程测试、气密性测试、外观视觉检查、EOL测试等<br />
                                整线采用高密度防错技术（防错率达100%），通过全流程生产特性数据的自动测量、采集和分析，实现整机产品的功能测试和质量控制预警管理，100%进行EOL测试，配合以全域NVH测试（噪声、脉冲）分析，确保每件产品的质量得到有效保证
                            </div>
                        </div>
                        <div class="img-box">
                            <img data-src="/assets/manufacture/engine/taizhou/tz1-4.jpg" alt="">
                        </div>
                    </div>

                    <div class="swiper-slide">
                        
                        <div class="text-box ">
                            <div class="title">
                                质量保证
                            </div>
                            <div class="destils">
                                蜂巢蔚领基于IATF16949质量管理体系，构建成熟度管理体系、8QB、标杆线体等管理模型，并推动持续改进<br />
                                公司在产品设计开发、工艺设计开发、供应商开发及质量管理、来料检测、生产制造过程、物流与交付、顾客服务与关系维护等环节实现全流程质量控制<br />
                                建立了计量实验室，配备全球先进的检测设备和仪器，通过高频次产品检测和试验验证，确保产品质量一致性
                            </div>
                        </div>
                        <div class="img-box">
                            <img data-src="/assets/manufacture/engine/taizhou/tz1-5.jpg" alt="">
                        </div>
                    </div>
                </div>
                <div class="kv_pagination swiper-pagination left"></div>
            </div>
        </div>

    </div>
    <Footer></Footer>
</template>

<script setup>
import { ref, onMounted, onUnmounted, nextTick } from 'vue';
import Navbar from '@/components/Navbar.vue';
import Footer from '@/components/Footer.vue';
import Swiper from 'swiper/bundle';
import 'swiper/swiper-bundle.css';
import $ from 'jquery';

// 存储所有swiper实例，方便销毁
const swiperInstances = ref([]);

// 初始化所有轮播的核心函数
const initAllSwipers = async () => {
    await nextTick();

    const swiperElements = document.querySelectorAll('.swiper-item');

    swiperElements.forEach(el => {
        if (el) {
            const swiper = new Swiper(el, {
                speed: 1300,
                pagination: {
                    el: el.querySelector(".swiper-pagination"), // 绑定当前容器内的分页器
                    clickable: true,
                },
                direction: "horizontal",
                slidesPerView: 1,
                // spaceBetween: 20,
                simulateTouch: true,
                effect: 'fade',
                breakpoints: {
                    768: {},
                    1024: {}
                },
                // navigation: {
                //     nextEl: el.querySelector(".btn-r"),
                //     prevEl: el.querySelector(".btn-l"),
                //     disabledClass: 'swiper-button-disabled',
                // },
                on: {
                    // init: function () {
                    //     console.log('轮播初始化完成');
                    // },
                    // slideChangeTransitionStart(swiper) {
                    //     let swiperIndex = swiper.realIndex;
                    //     console.log('当前轮播索引：', swiperIndex);
                    // },
                },
            });
            swiperInstances.value.push(swiper); // 保存实例
        }
    });
};

// 页面挂载时初始化轮播
onMounted(() => {
    initAllSwipers();
});

// 页面卸载时销毁轮播实例（防止内存泄漏）
onUnmounted(() => {
    swiperInstances.value.forEach(swiper => {
        swiper.destroy(true, true);
    });
    swiperInstances.value = [];
});
</script>

<script>
export const pageConfig = {
    title: '变速器泰州工厂 - 蜂巢汽车官网',
    keywords: '蜂巢,蜂巢汽车,发动机,变速器,电子',
    description: '蜂巢汽车科技集团有限公司，是一家掌握从传统动力到混合动力再到纯电动力（含控制器）全领域动力总成、汽车智能化集成系统等核心技术的零部件企业，具备完整的软、硬件产业链；能为客户提供高效节能环保的汽车动力总成、智能化出行解决方案',
    outputPath: 'manufacture/en/taizhou.html'
};

import { createApp } from 'vue';
import App from './taizhou.vue';
import store from '@/store/index';
import "@/assets/styles/global.scss";
import "@/assets/styles/manufacture-detail.scss";

function mountApp() {
    const appNode = document.getElementById('app');
    if (appNode) {
        if (appNode._vueApp) {
            appNode._vueApp.unmount();
            delete appNode._vueApp;
        }
        const app = createApp(App);
        app.use(store);
        appNode._vueApp = app.mount(appNode);
    }
}

document.addEventListener('DOMContentLoaded', mountApp);

if (module.hot) {
    module.hot.accept('./taizhou.vue', () => {
        mountApp();
    });
}
</script>

<style lang="scss"></style>
